module.exports = __webpack_public_path__ + "img/demo.eb38838f.jpg";